import { render } from "./tik.vue?vue&type=template&id=2354696c"
import script from "./tik.vue?vue&type=script&lang=js"
export * from "./tik.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__